import React, { useState } from "react";
import Skeleton from "../shared/skeleton";
import Form from "../_lib/form/form";
import { useHistory } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { submit } from '../../actions/a.payment-form'

const PaymentForm = () => {
    const [invalidInput, setInvalidInput] = useState(null);
    const history = useHistory();
    const dispatch = useDispatch();

    const getFormRows = () => {
        let rows = [],
            cols = [];

        cols.push({
            className: "col-sm-12",
            items: [
                {
                    type: "textbox",
                    name: "FirstName",
                    label: "نام ",
                    defaultValue: "",
                    required: true,
                    attr: { "data-checkify": "required,minlen=2" },
                },
            ],
        });

        rows.push({ cols });
        cols = [];

        cols.push({
            className: "col-sm-12",
            items: [
                {
                    type: "textbox",
                    name: "LastName",
                    label: "نام خانوادگی ",
                    defaultValue: "",
                    required: true,
                    attr: { "data-checkify": "required,minlen=4" },
                },
            ],
        });

        rows.push({ cols });
        cols = [];

        cols.push({
            className: "col-sm-12",
            items: [
                {
                    type: "textbox",
                    name: "Mobile",
                    label: "موبایل ",
                    defaultValue: "",
                    required: true,
                    attr: { "data-checkify": "required,number,maxlen=11,minlen=11" },
                },
            ],
        });

        rows.push({ cols });
        cols = [];

        cols.push({
            className: "col-sm-12",
            items: [
                {
                    type: "textbox",
                    name: "PaidPrice",
                    label: "مبلغ (ریال) ",
                    defaultValue: "",
                    required: true,
                    attr: { "data-checkify": "required,number,maxlen=11,minlen=3" },
                },
            ],
        });

        rows.push({ cols });
        cols = [];

           cols.push({
            className: "col-sm-12",
            items: [
                {
                    type: "textarea",
                    name: "Description",
                    defaultValue: "",
                    label: "توضیحات",
                    required: false
                },
            ],
        });

        rows.push({ cols });

        return rows;
    };

    const { isFetching } = useSelector((state) => state.PaymentForm);

    const handleSubmit = async (data, afterSubmit) => {
        const dataObj = JSON.parse(await data.get("Data").text());
console.log(1,dataObj);
        const { FirstName, LastName, Mobile, PaidPrice } = dataObj;

        if (!FirstName?.length > 0) {
            setInvalidInput("پر کردن نام الزامی است.");
            afterSubmit();
            return;
        }

        if (!LastName?.length > 0) {
            setInvalidInput("پر کردن نام خانوادگی الزامی است.")
            afterSubmit();
            return;
        }

        if (!Mobile?.length > 0) {
            setInvalidInput("پر کردن موبایل الزامی است.")
            afterSubmit();
            return;
        }

        if (!PaidPrice?.length > 0) {
            setInvalidInput("پر کردن مبلغ الزامی است.")
            afterSubmit();
            return;
        }

        setInvalidInput(null)

        dispatch(submit(data));

    };

    if (isFetching)
        return (
            <Skeleton
                align="center"
                width={40}
                schema={skeletonSchema}
                animation="blink"
            />
        );

    return (
        <div className="free-payment__form">
            <h4>فرم پرداخت آزاد</h4>
            <Form
                rows={getFormRows()}
                onSubmit={handleSubmit}
                onInvalid={() => { }}
                submitButtonText="پرداخت"
            />
            {invalidInput && (
                <h5 className="payment-form__confirmationError">
                    {invalidInput}
                </h5>
            )}
        </div>
    );
};

const skeletonSchema = [[[100, 40]], [[100, 215]], [[100, 30]], [[100, 30]]];

export default PaymentForm;
